import { Blockchain } from "@rarible/api-client"
import { defineChain } from "viem"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const megaethTestnetV2 = defineChain({
  id: 6343,
  name: "MegaETH Testnet V2",
  nativeCurrency: {
    name: "MegaETH Testnet V2 Ether",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [
        "https://timothy.megaeth.com/mafia/rpc/p46e7y8dpzvg01pen56xfgmu43eteuhfr717h4hb",
      ],
      webSocket: [
        "https://timothy.megaeth.com/mafia/ws/p46e7y8dpzvg01pen56xfgmu43eteuhfr717h4hb",
      ],
    },
  },
  blockExplorers: {
    default: {
      name: "MegaETH Testnet V2 Explorer",
      url: " https://megaeth-testnet-v2.blockscout.com",
    },
  },
  testnet: true,
})

export const megaEthTestnetV2Config: StaticEthereumBlockchainConfig = {
  name: "MegaETH",
  icon: "/images/blockchains/mega-eth.svg",
  isEvm: true,
  testnet: true,
  isTestnet: true,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://megaethtestnetv2-api.rarible.org",
  chainId: 6343,
  blockchain: Blockchain.MEGAETHTESTNETV2,
  chainName: "MegaETH Testnet V2",
  exchange: {
    v2: "0x3F246Dfcc7DA7B4f2796b69c2A520162961eFd3a",
    wrapper: "0x8765C39d67F3921Eb5604559b9F38dFa0cD855b7",
  },
  blockExplorers: [
    {
      url: " https://megaeth-testnet-v2.blockscout.com/",
      icon: "/images/scanner.svg",
      adress: "https://megaeth-testnet-v2.blockscout.com/address/${adrress}",
    },
  ],
  rpcUrls: [
    {
      url: "https://timothy.megaeth.com/mafia/rpc/p46e7y8dpzvg01pen56xfgmu43eteuhfr717h4hb",
      isPublic: true,
    },
  ],
  privateRpcNodeSlug: "testnet-megaethv2-node",
  transferProxies: {
    nft: "0x12181eDedD1f81838580668bb5B50e1030df4667",
    erc721Lazy: "0x5C938272c3305f40691B584E1243c30118640cCB",
    erc20: "0x147d06FbDA085C0455615E554D87262B0726ad0c",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId(
      "MEGAETHTESTNETV2:0x0000000000000000000000000000000000000000",
    ),
    symbol: "ETH",
    name: "ETH",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId(
      "MEGAETHTESTNETV2:0x4200000000000000000000000000000000000006",
    ),
    symbol: "WETH",
    name: "WETH",
    decimals: 18,
  },
  addFundsLink: "https://docs.megaeth.com/faucet",
  hasStabilityProtocol: true,
  viem: megaethTestnetV2,
}

export const getMegaEthTestnetV2Config = (): StaticEthereumBlockchainConfig =>
  megaEthTestnetV2Config
